module.exports = __webpack_public_path__ + "img/arrow-down.117cf033.svg";